import React, {useState} from 'react';

export const TranslationContext = React.createContext()

const TranslationProvider = ({children, translations: originalTranslations}) => {
    const [translations, _] = useState(JSON.parse(originalTranslations))

    const trans = (key, cap) => {
       
        if(translations[key]){
            if(cap){
                return translations[key].charAt(0).toUpperCase() + translations[key].slice(1);
            }
            else{
                return translations[key]
            }
           
        }
      
        return `untranslated key: ${key}`
        
    }

    const value = {trans}

    return (
        <TranslationContext.Provider value={value}>
            {children}
        </TranslationContext.Provider>
    );
};

export default TranslationProvider;